import React from "react";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./TaskHeader.module.scss";

function TaskHeader(props) {
  const { isEnabled, title,
    closeTask, maximizeTask, restoreTask,
    toggleShowSettings,
    enableDragging, disableDragging, 
    showNoControls, isMoveable,
    showMaximize, showClose, isMaximized } = props;

  const hideSessionSettings = true;
  const disabledOpacity = 0.7;

  const toggleMaximizeTask = () => {
    if (isMaximized) restoreTask();
    else maximizeTask();
  };

  const disabledStyle = {
    opacity: disabledOpacity
  };

  const renderHeaderButton = (icon, onClickHandler) => {
    return (
      <Button
        stylingMode={'text'}
        icon={icon}
        className={classes.titleButton}
        style={isEnabled ? null : disabledStyle}
        onClick={onClickHandler}
        disabled={!isEnabled}
      />
    );
  };

  const renderHeader = () => {
    return (
      <div className={cn(classes.taskHeader, 'dx-theme-accent-as-background-color')} onMouseOver={enableDragging} onMouseLeave={disableDragging} style={{ cursor: isMoveable ? "move" : "default" }}>
        {showNoControls || hideSessionSettings
          ? <div />
          : renderHeaderButton('preferences', toggleShowSettings)
        }

        <div className={cn("ui-font-bigger-1", "ui-font-bold-1")} style={isEnabled ? null : disabledStyle}>
          {title}
        </div>

        {showNoControls
          ? <div />
          : <div>
            {showMaximize
              ? renderHeaderButton(isMaximized ? 'unselectall' : 'fullscreen', toggleMaximizeTask)
              : null
            }
            {showClose
              ? renderHeaderButton('close', closeTask)
              : null}
          </div>
        }
      </div>
    );
  };

  return renderHeader();
}

export default TaskHeader;
